// import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
// import React, { useState } from 'react';
import { AppContext } from './context/AppContext';
import DigitalClock from './DigitalClock';
import { useContext, useEffect, useRef, componentDidMount } from 'react';
import { useWakeLock } from 'react-screen-wake-lock';
import generateGameID from './GenerateGameID';
import { incrementCounter } from './handleCounters.js';

function Main(props) {
    const { FLAGS, setFlags, timer, setTimer, running, setRunning, events, setEvents,
        period, setPeriod, counters, setCounters, teams, setTeams, goalies, setGoalies,
        gameID, setGameID, preferences, setPreferences } = useContext(AppContext);
    const GlobalFlags = FLAGS;

    const navigate = useNavigate();

    useEffect(() => {
        // every time I go to the main page, close the popup
        props.hideHamburger();
    }, [])

    function saveDataLocal() {
        localStorage.setItem("hockeyData.flags", JSON.stringify(FLAGS));
        localStorage.setItem("hockeyData.counters", JSON.stringify(counters));
        localStorage.setItem("hockeyData.teams", JSON.stringify(teams));
        localStorage.setItem("hockeyData.goalies", JSON.stringify(goalies));
        localStorage.setItem("hockeyData.events", JSON.stringify(events));
        localStorage.setItem("hockeyData.gameID", JSON.stringify(gameID));
        if (GlobalFlags.debug) {
            console.log("savingData", events);
            console.log("savingData", FLAGS);
            console.log("savingData", counters);
            console.log("savingData", teams);
            console.log("savingData", goalies);
            console.log("savingData", gameID);
        }
    }
    useEffect(() => { saveDataLocal(); }, [events]);

    const listRef = useRef(null);

    useEffect(() => {
        if (listRef.current) {
            listRef.current.scrollTop = listRef.current.scrollHeight;
        };
    }, [events]);

    function resetData() {
        const confirmBox = window.confirm(
            "Do you really want to Reset data"
        )
        if (confirmBox === true) {
            console.log("resetting data")
            setGameID(generateGameID());
            stopTimer();
            setEvents([]);
            setGoalies({ home: 'Default', visitor: 'Default' });
            setCounters({
                HomeGoal: 0,
                VisitorShot: 0,
                HomeShot: 0,
                VisitorGoal: 0,
                HomeMiss: 0,
                VisitorMiss: 0
            });// end setCOunters
            setTeams({ homeShortName: '', visitorShortName: '' });
            const date = new Date();
            console.log(date.toISOString());
            setTimer((preferences.defaultPeriod * 60))
            setGameID(generateGameID());
        }
    }

    function startTimer() {
        setRunning(true);
    }

    function stopTimer() {
        setRunning(false);
    }

    function recordEvent(eventType) {
        if (FLAGS.debug) { console.log("recording event " + eventType); }
        setEvents([...events, { period: period, time: fullShort(timer), eventType: eventType }]);
        incrementCounter(eventType, setCounters, counters);
    }

    return (<div id='mainApp'>
        <div className="grid-container">
            <div className="grid-item">
                <h1>Score Tracker</h1>
            </div>

            <div className="grid-item grid-clock" id='clockDiv'>
                <DigitalClock showMicroAdjust={true} />
            </div>

            <div className="grid-item counter-grid " id='counterDiv'>
                <div className='counter-cell counter-TeamName' >
                    {/* <div className='counter-cell' onClick={() => navigate('/setteamname')}> */}
                    Home<br />{teams.homeShortName}
                </div>
                <div>
                    {/* <div className='counter-cell' onClick={() => navigate('/setteamname')}> */}
                </div>
                <div className='counter-cell counter-TeamName'>
                    {/* <div className='counter-cell' onClick={() => navigate('/setteamname')}> */}
                    Visitor<br />{teams.visitorShortName}
                </div>
                <div className='counter-cell digitalNumber countertd' onClick={() => recordEvent(FLAGS.shotIncludesGoal ? 'HomeShotAndGoal' : "HomeGoal")}>{counters.HomeGoal}</div>
                <div className='counter-cell' >
                    Goal </div>
                <div className='counter-cell digitalNumber countertd' onClick={() => recordEvent(FLAGS.shotIncludesGoal ? 'VisitorShotAndGoal' : "VisitorGoal")} >{counters.VisitorGoal}
                </div>

                <div className='counter-cell digitalNumber countertd' onClick={() => recordEvent("HomeShot")} >{counters.HomeShot}
                </div>
                <div className='counter-cell' >Shots
                </div>
                <div className='counter-cell digitalNumber countertd' onClick={() => recordEvent("VisitorShot")} >{counters.VisitorShot}
                </div>


                {/*
                 {FLAGS.trackMisses ? (<tr><td onClick={() => recordEvent("HomeMiss")} className='digitalNumber countertd'>{counters.HomeMiss}</td>
                    <td>Miss</td>
                    <td onClick={() => recordEvent("VisitorMiss")} className='digitalNumber countertd'>{counters.VisitorMiss}</td></tr>
                ) : <tr></tr>} 
                 */}
            </div> {/*end counterDiv */}

            {
                !FLAGS.toggleTouchTime && (
                    <div className="grid-item" id='startStopButtonDiv'>
                        <button className='start' disabled={running} onClick={startTimer}>Start</button>
                        <button className='stop' disabled={!running} onClick={stopTimer}>Stop</button>
                        {/* {FLAGS.editEvent && <EditEventWindow className='editEventWindow' events={events} setEvents={setEvents} decrementCounter={decrementCounter} document={document} />} */}
                    </div>
                )
            }
            <div className="grid-item buttonRow" id='setupButtonDiv'>
                {/* <button id='setTeamButton' className='flex-button' onClick={() => navigate('/setteamname')}> Set Teams </button> */}

                <button id='setGoalieButton' className='setGoalie flex-button extraSettings' onClick={() => navigate('/setgoalie')} >Set Goalies</button>
                <button id='setTeamButton' className='setTeam flex-button extraSettings' onClick={() => navigate('/setteamname')} >Set Teams</button>
                <button id='resetButton' className='reset flex-button' onClick={resetData}>Reset</button>
                <button id='saveButton' className='flex-button' onClick={() => handleDownload(events, gameID, counters, teams)}>Down<wbr />load</button>
                {FLAGS.uploadData && <button id='uploadButton' className='flex-button' onClick={() => handleUpload(events, gameID, counters, teams)}>Save Online</button>}
            </div> {/* Button Row */}

            {/* <Link to="/editevents" > */}
            <div className=" grid-item scrollable-div eventWindow" id="scrollable-div" ref={listRef} onClick={() => navigate('/editevents')}>
                {/* <ul>
                    {events.map((event, index) => (
                        <li className='event' key={index}>
                            {event.period},{event.time},{event.eventType}
                        </li>
                    ))}
                </ul> */}
                {events.map((event, index) => (
                    <div className='event' key={index}>
                        {event.period}, {event.time}, {event.eventType}
                    </div>
                ))}

            </div> {/* End of the Event List */}

            {false &&
                <div className="row grid-item footer">
                    <h1>Project Footer</h1>
                </div>
            }

        </div > {/* End of Grid */}
    </div >
    )
}

function handleUpload(events, gameID, counters, teams) {
    const confirmBox = window.confirm(
        "Upload is not Implemented yet"
    )
    console.log('Uploading not implemented ' + (confirmBox ? "ok" : "cancel"))
}

function fullShort(timer) {
    if (timer < 60) {
        return formatSeconds(timer, 2);
    } else {
        return formatSeconds(timer, 0);
    }
}

function formatSeconds(seconds, decimalPlaces = 0) {

    // show different times depending on "stuff"
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = Math.floor(seconds % 60);

    // Format minutes and seconds with leading zeros
    const formattedMinutes = String(minutes).padStart(2, '0');
    const formattedSeconds = String(remainingSeconds).padStart(2, '0');

    // If decimal places are required, calculate the fractional part
    if (decimalPlaces > 0) {
        // const fractionalSeconds = (remainingSeconds - Math.floor(remainingSeconds)).toFixed(decimalPlaces);
        // return `${formattedMinutes}:${formattedSeconds}${fractionalSeconds.substring(1)}`;
        const fractionalSeconds = Math.floor((seconds - Math.floor(seconds)) * (10 ** decimalPlaces));
        const formattedfractionalSeconds = String(fractionalSeconds).padStart(decimalPlaces, '0');


        // \?).toFixed(decimalPlaces);
        return `${formattedMinutes}:${formattedSeconds}.${formattedfractionalSeconds}`;
    } else {
        return `${formattedMinutes}:${formattedSeconds}`;
    }
}

function savePercentage(goals, shots) {
    return (Math.floor((1 - goals / shots) * 1000) / 10 + '%')
}

function handleDownload(events, gameID, counters, teams) {
    const data = events
    const csvContent = "data:text/csv;charset=utf-8,"
        + "Game Summary\n"
        + "v0.1," + gameID.timestamp + "," + gameID.uuid + "\n"
        + "Home Short Name: " + teams.homeShortName + "\n"
        + " Age & Division: " + teams.homeAgeDivision + "\n"
        + "Visitor Short Name: " + teams.visitorShortName + "\n"
        + " Age & Division: " + teams.visitorAgeDivision + "\n"
        + "Home Save: " + savePercentage(counters.VisitorGoal, counters.VisitorShot) + '\n'
        + "Visitor Save:  " + savePercentage(counters.HomeGoal, counters.HomeShot) + '\n'
        + "Home Goal: " + counters.HomeGoal + '\n'
        + "Visitor Goal: " + counters.VisitorGoal + '\n'
        + "Home Shots: " + counters.HomeShot + '\n'
        + "Visitor Shots: " + counters.VisitorShot + '\n'
        + "Home Miss: " + counters.HomeMiss + '\n'
        + "Visitor Miss: " + counters.VisitorMiss + '\n'
        + data.map(e => Object.values(e).join(",")).join("\n");
    const encodedUri = encodeURI(csvContent);

    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    // const isoDate = `${year}-${month}-${day}`;
    const isoDate = date.toISOString().substring(0, 10)
    console.log(isoDate);

    const link = document.createElement("a");

    link.setAttribute("href", encodedUri);
    link.setAttribute("download", `HockeyShotData-${isoDate}.txt`);
    document.body.appendChild(link); // Required for Firefox
    link.click();
    link.remove();

}


export default Main;

